export default __webpack_public_path__ + "static/media/simon game.f6edad2e.png";